import React from 'react';
import { Schema } from '../../utils/form';
import { FormattedMessage } from 'react-intl';

export default Schema.object({
  farol: Schema.string().label(<FormattedMessage id="farol" />),
});
